module.exports = __webpack_public_path__ + "OpenSans-Semibold-08952b029e4decbc8ef9fb553cae8cea.woff2";